import { AsYouType, CountryCode } from 'libphonenumber-js';

const formatPhoneNumber = (phoneNumber: string, countryCode: CountryCode = 'BR'): string => new AsYouType(countryCode)
	.input(phoneNumber);

export default formatPhoneNumber;
